export default ((getPromise, delay = 300) => {
    let lock;
    let next = null;
    let outerReject = null;

    const logError = t => e => {
        console.log([t, e].join(': '));
    };

    let getLock = () => Promise.race([
        Promise.resolve(getPromise()).then(
            () => new Promise(resolve => {
                setTimeout(resolve, delay);
            }),
            logError('Error in original function')
        ).then(() => {
            outerReject = null;
            lock = null;
        }),
        new Promise((_, reject) => {
            outerReject = reject;
        })
    ]);

    let runWatcher = () => {
        if (next) {
            console.log('next');
            clearTimeout(next);
            next = null;
        }

        if (lock) {
            console.log('Lock');
            lock.then(runWatcher, logError('Error in runWatcher'));
            return;
        }

        next = setTimeout(() => {
            next = null;
            console.log('Executing watcher');
            lock = getLock();
        }, 100);
    };

    return {
        lock() {
            if (next) {
                console.log('next in lock');
                clearTimeout(next);
                next = null;
            }

            if (lock && outerReject) {
                console.log('rejecting');
                lock.then(null, logError('Error in lock'));
                outerReject('unlock');
            }

            lock = getLock();
        },
        watch: runWatcher
    };
});